const config = {
  apiKey: 'AIzaSyDyja_rdSqMtP-5tKVYHq1Y3ki_GY6B1xY',
  authDomain: 'gesia-studio.firebaseapp.com',
  databaseURL: 'https://gesia-studio.firebaseio.com',
  projectId: 'gesia-studio',
  storageBucket: 'gesia-studio.appspot.com',
  messagingSenderId: '1063178240066',
  appId: '1:1063178240066:web:9242f3c7cc4df995'
};

export default config;